module.exports = __webpack_public_path__ + "static/media/moto guzzi.f117053b.png";